// あなたの言葉辞典 — 全メモから独自の言葉・表現を AI が抽出して辞典化
import { escapeHtml, screenHead, showScreen, showLoading, hideLoading, toast, renderHistorySection, bindHistoryHandlers } from '../ui.js';
import { fetchVocabulary } from '../api.js';
import { getAllBooks, saveAiHistory, getAiHistoryByType } from '../cache.js';

export async function showVocabularyScreen() {
  const histItems = await getAiHistoryByType('vocabulary');
  renderEntry(histItems);
}

function renderEntry(histItems) {
  const html = `
    ${screenHead('あなたの言葉辞典')}
    <p style="color:var(--dim);font-size:13px;line-height:1.75;margin:0 0 20px;">
      全メモを横断して、あなたが繰り返し戻ってくる「独自の言葉・表現」を AI が抽出します。<br/>
      思想が言葉として染み付いてきた証拠を、辞典として残せます。
    </p>
    <button class="btn btn--ink btn--block" id="btn-go" type="button">
      <svg class="icon"><use href="#i-sparkles"/></svg>
      <span>あなたの言葉を抽出する</span>
    </button>
    <p style="margin-top:14px;font-size:11px;color:var(--mute);line-height:1.6;font-family:var(--font-mono);letter-spacing:0.08em;">
      使用モデル: claude-opus-5-5 · 1 回 約 5-10 円
    </p>
    ${renderHistorySection(histItems)}
  `;
  const screen = showScreen('vocabulary', html);
  screen.querySelector('[data-action="back"]').addEventListener('click', () => window.history.back());
  screen.querySelector('#btn-go').addEventListener('click', runVocab);
  bindHistoryHandlers(
    screen,
    histItems,
    (entry) => renderResult(entry.payload),
    () => showVocabularyScreen()
  );
}

async function runVocab() {
  const all = await getAllBooks();
  const eligible = all.filter((b) => (b.note || '').trim().length > 100);
  if (eligible.length < 3) {
    toast('メモのある書籍が 3 冊以上必要です');
    return;
  }
  showLoading('AI が言葉を集めています…');
  try {
    const payload = eligible.map((b) => ({ name: b.name, note: b.note }));
    const result = await fetchVocabulary(payload);
    await saveAiHistory({
      type: 'vocabulary',
      title: `言葉辞典 (${(result.entries || []).length} 語)`,
      subtitle: (result.entries || []).slice(0, 3).map((e) => e.term).join(' · '),
      context: { count: eligible.length },
      payload: result,
    });
    renderResult(result);
  } catch (e) {
    console.error(e);
    toast('抽出に失敗しました');
  } finally {
    hideLoading();
  }
}

export function renderFromHistory(entry) {
  renderResult(entry.payload);
}

function renderResult(data) {
  const entries = data.entries || [];
  const html = `
    ${screenHead('あなたの言葉辞典')}
    <p style="color:var(--dim);font-size:13px;line-height:1.75;margin:0 0 24px;">
      ${entries.length} 個の言葉を抽出しました。
    </p>
    ${entries.map((e) => `
      <article class="vocab-card">
        <div class="vocab-card__head">
          <h3 class="vocab-card__term">${escapeHtml(e.term || '')}</h3>
          <span class="vocab-card__count">×${e.count || ''}</span>
        </div>
        ${e.gloss ? `<p class="vocab-card__gloss">${escapeHtml(e.gloss)}</p>` : ''}
        ${e.exampleQuote ? `<blockquote class="vocab-card__quote">「${escapeHtml(e.exampleQuote)}」</blockquote>` : ''}
        ${e.books?.length ? `<div class="vocab-card__books">${(e.books || []).map((b) => `<span class="chip">${escapeHtml(b)}</span>`).join('')}</div>` : ''}
      </article>
    `).join('')}
    <button class="btn btn--block btn--ghost" id="btn-regen" type="button" style="margin-top:24px;">
      <svg class="icon"><use href="#i-refresh"/></svg>
      <span>再抽出する</span>
    </button>
  `;
  const screen = showScreen('vocabulary', html);
  screen.querySelector('[data-action="back"]').addEventListener('click', () => window.history.back());
  screen.querySelector('#btn-regen').addEventListener('click', () => showVocabularyScreen());
}
